module.exports = __webpack_public_path__ + "media/images/athletes/2212-b6431a05d066bc9bcd430eb19d2a7284.png";